'use client';
import React, { memo } from 'react';

import { Button, ButtonProps, cn } from '@nextui-org/react';

export type BtnVariant =
	| 'default'
	| 'bordered'
	| 'disabled'
	| 'light'
	| 'withIcon'
	| 'transparent';

interface IButtonProps extends Omit<ButtonProps, 'variant'> {
	variant?: BtnVariant;
}

const DEFAULT_BTN_CLASS =
	'center min-h-[42px] w-fit rounded-[50px] px-3 py-1 sm:px-6 sm:py-2 text-center text-sm font-semibold focus:outline-none overflow-hidden bg-transparent border-none hover:opacity-90 transition-opacity';

const getVariantBtnClass = (variant?: BtnVariant) => {
	switch (variant) {
		case 'bordered':
			return 'bg-white text-bittersweet border border-solid border-bittersweet';
		case 'disabled':
			return 'bg-silver text-gray border border-solid border-silver';
		case 'light':
			return 'bg-mauvelous text-bittersweet border border-solid border-mauvelous';
		case 'withIcon':
			return 'bg-transparent text-black border border-solid border-black';
		case 'transparent':
			return '';
		case 'default':
			return 'bg-bittersweet text-white';
		default:
			return 'bg-bittersweet text-white';
	}
};

const IButton: React.FC<IButtonProps> = ({
	className = '',
	children,
	variant = 'default',
	...props
}) => {
	return (
		<Button
			className={cn(
				DEFAULT_BTN_CLASS,
				getVariantBtnClass(variant),
				className
			)}
			{...props}
		>
			{children}
		</Button>
	);
};

export default memo(IButton);
